export { default as OldDivider } from './OldDivider'
export { default as OldText } from './OldText'
export { default as OldLink } from './Link'
export { default as OldSpinner } from './OldSpinner'
export { default as Flex } from './Flex'
export { SkeletonRect, SkeletonCir } from './Skeleton'
export { default as Spacer } from './Spacer'
export { default as Icon } from './Icon'
export { Checkbox } from './Checkbox'
export { default as InputHelperText } from './InputHelperText'
export { default as InputErrorMessage } from './InputErrorMessage'
export { default as Content } from './Content'
export { default as ToolTipText } from './ToolTipText'
export { default as ToolTipMobileText } from './TooltipMobileText'
export { default as PaymentButton } from './PaymentButton'
export { default as ButtonDone } from './ButtonDone'

// редизайн
export { default as Spinner } from './redesign/Spinner'
export { default as Text } from './redesign/Text'
export { default as Link } from './redesign/Link'
export { default as TextArea } from './redesign/TextArea'
export type { CustomTextAreaProps as TextAreaProps } from './redesign/TextArea'
export { default as Divider } from './redesign/Divider'
export { default as Dot } from './redesign/Dot'
export { default as TextButton } from './redesign/TextButton'
export { default as Marquee } from './redesign/Marquee'
